import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import mainDe from './translations/de/main.json';
import mainEn from './translations/en/main.json';
import mainFr from './translations/fr/main.json';
import mainIt from './translations/it/main.json';
import errorDe from './translations/de/error.json';
import errorEn from './translations/en/error.json';
import errorFr from './translations/fr/error.json';
import errorIt from './translations/it/error.json';

export const defaultNS = 'main';
export const resources = {
  de: {
    main: mainDe,
    error: errorDe
  },
  en: {
    main: mainEn,
    error: errorEn
  },
  fr: {
    main: mainFr,
    error: errorFr
  },
  it: {
    main: mainIt,
    error: errorIt
  }
} as const;

let lang = 'de';

if (sessionStorage.getItem('ptPreferredLanguage')) {
  lang = sessionStorage.getItem('ptPreferredLanguage') as string;
}

i18n
  .use(initReactI18next)
  .init({
    lng: lang,
    fallbackLng: ['de', 'en', 'fr', 'it'],
    ns: ['main'],
    defaultNS,
    resources,
    returnNull: false
  })
  .then(() => {
    sessionStorage.setItem('ptPreferredLanguage', lang);
  })
  .catch(() => {
    // do nothing
  });
